import loadCommonFeatures from './common';
import loadTraits from './traits';
import loadManagers from './managers';
import loadCommands from './commands';

export default (grapesjs) => {
  loadCommonFeatures(grapesjs);
  loadTraits(grapesjs);
  loadManagers(grapesjs);
  loadCommands(grapesjs);
}